// extracted by mini-css-extract-plugin
module.exports = {"containerToDos":"styles_containerToDos__3zd4A","navigationToDos":"styles_navigationToDos__2Ac2b","containerCards":"styles_containerCards__1XMe7","module":"styles_module__3sMy6"};